import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { Observable } from 'rxjs';
import { CreateManagementReportExecutionRequestDto } from '../dtos/create-management-report-execution.request.dto';
import { ListManagementReportExecutionRequestDto } from '../dtos/list-management-report-execution.request.dto';
import { ManagementReportExecutionResponseDto } from '../dtos/management-report-execution.response.dto';
import { PreviewManagementReportExecutionResponseDto } from '../dtos/preview-management-report-execution.response.dto';

export abstract class ManagementReportExecutionRepository {
  abstract list(
    request: ListManagementReportExecutionRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<ManagementReportExecutionResponseDto>>
  >;

  abstract show(
    request: RefId,
  ): Observable<ApiResponse<ManagementReportExecutionResponseDto>>;

  abstract create(
    request: CreateManagementReportExecutionRequestDto,
  ): Observable<ApiResponse<ManagementReportExecutionResponseDto>>;

  abstract download(
    request: RefId,
  ): Observable<ApiResponse<{ viewUrl: string }>>;

  abstract preview(
    request: RefId,
  ): Observable<ApiResponse<PreviewManagementReportExecutionResponseDto>>;

  abstract delete(request: RefId): Observable<ApiResponse<void>>;
}
